import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { type Epic } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { from } from 'rxjs/observable/from';
import {
	checkConfluenceAccessWithRetry,
	fetchConfluenceAccessRequestCapabilities,
	INLINE_JOIN_CONFLUENCE,
	inlineJoinConfluenceFailed,
} from '../actions';
import { getCloudId } from '../context/selectors';
import { type State } from '../types';
import { type Action } from 'redux';
import { AccessRequestCapabilityType } from '../confluence/access-request-capabilities/types';
import { fetchFailed, fetchSuccess } from '../../common/fetch-request-analytics';
import { inlineJoin$ } from './inline-join';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { catchError } from 'rxjs/operators/catchError';

const confluenceInlineJoin: Epic<Action, State> = (action$, store) =>
	action$.ofType(INLINE_JOIN_CONFLUENCE).switchMap(() => {
		const state = store.getState();
		const cloudId = getCloudId(state);

		return inlineJoin$('confluence', cloudId).pipe(
			mergeMap(({ status, result }) => {
				const isRaFlow = result === AccessRequestCapabilityType.PENDING_REQUEST_CREATED;
				/*
					For RA flow we just need to fetch access request capabilities from identity as it'll refresh the main screen 
					to show pending RA. We must not checkConfluenceAccessWithRetry as it'll send requests to Confluence
					whereby the user is still pending admin approval. All requests to Confluence endpoint will result in 403
					as expected because they don't have Confluence permission yet. 
				*/
				if (isRaFlow) {
					fetchSuccess('auto.ra.confluence');
				} else {
					fetchSuccess('inline.join.confluence');
				}
				return from([
					isRaFlow ? fetchConfluenceAccessRequestCapabilities() : checkConfluenceAccessWithRetry(),
				]);
			}),
			catchError((err) => {
				fetchFailed('inline.join.confluence', err);
				return of(inlineJoinConfluenceFailed());
			}),
		);
	});

export default confluenceInlineJoin;
